import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import Rules from '../../pages/rules/main/Rules';
import { useModal } from '../../../hooks/useModal';

const RulesModal = React.forwardRef(function RulesModal({}, ref) {
  const { closeModal, id } = useModal();
  return (
    <CustomModal className={'custom-modal_fullpage custom-modal_rules'}>
      <Rules
        closeModal={() => {
          closeModal({ id });
        }}
        isModal
      />
    </CustomModal>
  );
});
export default RulesModal;
RulesModal.propTypes = {};
